import { Component, OnInit, ViewChild, ViewContainerRef, NgModule, Compiler } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WaitModalComponent } from '../wait-modal/wait-modal.component';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { AppComponent } from '../../app.component';
import { SignInMainComponent } from './sign-in-main.component';
import { SignInService } from '../../service/sign-in.service';
import { DisplayService } from '../../service/display.service';
import { TokenManager } from '../../service/web-api.service';
import { AuthService } from '../../service/auth.service';
import { CustomViewService } from '../../service/custom-view.service';
import { environment } from '../../../environments/environment';
declare let gtag: any; // グローバル変数gtagを解決

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  providers: [SignInService, DisplayService, CustomViewService]
})
export class SignInComponent implements OnInit {

  // 画面ID
  readonly SCREEN_ID = 'O01';

  /**ユーザ名 */
  public userId: string;
  /**パスワード */
  public password: string;
  /**エラーメッセージ */
  public messages: any[];
  /** タイトルロゴ */
  public dispZ0001: string;
  /** ログイン時のメッセージ */
  public dispO0101: string;

  // ページ番号定義
  public pageNo: number;
  // 操作クラス定義
  public comp: SignInMainComponent;
  // テンプレートファイ名（HTML）
  public templateHtml: string;
  // テンプレートファイル（CSS）
  public templateCss: string;
  // 画面資材ルートURL
  public assetsBaseUrl: string;
  // 共通画面資材URL
  public assetsPortalBaseUrl: string;

  // 共通画面資材URL
  public serviceName: string;

  @ViewChild('waitModal', { static: false }) waitModal: WaitModalComponent;
  @ViewChild('dest', { read: ViewContainerRef, static: false })
  public dest: ViewContainerRef;

  constructor(
    public router: Router,
    private signInService: SignInService,
    private displayService: DisplayService,
    private authService: AuthService,
    private appComponent: AppComponent,
    private customViewService: CustomViewService,
    private compiler: Compiler) { }

  /**
   * 初期処理
   */
  async ngOnInit() {
    this.pageNo = 1;

    if (this.appComponent.dispZ0000 === undefined) {
      await this.appComponent.getDisplayInfo();
    }

    // 読み込まれるHTML名の取得
    this.serviceName = '';
    if (this.appComponent.dispZ0000 === '') {
      this.serviceName = 'portal';
    } else {
      this.serviceName = this.appComponent.dispZ0000;
    }
    this.assetsBaseUrl = environment.storageBaseUrl + '/' + this.serviceName + '/adume';
    this.assetsPortalBaseUrl = environment.storageBaseUrl + '/portal';
    this.templateHtml = this.assetsBaseUrl + '/html/sign-in/' + this.serviceName + '_sign-in';
    this.templateCss = this.assetsBaseUrl + '/css/' + this.serviceName + '_sign-in.css';

    // 画面カスタマイズ情報
    await this.displayService.execAuthDisplayInfo(this.SCREEN_ID).subscribe(data => {
      this.dispZ0001 = '';
      this.dispO0101 = '';
      if (data.displayInfo != null) {
        if (data.displayInfo.Z0001 != null) {
          this.dispZ0001 = data.displayInfo.Z0001;
        }
        if (data.displayInfo.O0101 != null) {
          this.dispO0101 = data.displayInfo.O0101;
        }
      }

      if (data.loginHintMailAddress != null) {
        this.userId = data.loginHintMailAddress;
        if (data.initialPageNo != null) {
          this.pageNo = parseInt(data.initialPageNo, 10);
        }
      } else {
        this.userId = '';
      }

      // カスタムページ表示
      this.directInjection();
    });
    this.password = '';
    this.messages = [];
  }

  /**
  * コンポーネントを生成し親コンポーネントに挿入する
  *
  */
  public async directInjection() {

    gtag('config', environment.analyticsId, {
      'page_path': '/html/sign-in/' + this.serviceName + '_sign-in' + '/' + this.pageNo,
      'page_title': 'sign-in',
    });

    gtag('config', environment.analyticsIdGa4, {
      'page_title': 'sign-in',
      'page_location': this.serviceName + '/sign-in/' + this.pageNo
    });

    // 元の要素をクリアする
    this.dest.clear();

    // テンプレートを取得
    let templateHtmlText = await this.customViewService.getText(this.templateHtml + '_' + this.pageNo + '.html').toPromise();
    let templateCssText = await this.customViewService.getText(this.templateCss).toPromise();
    templateCssText = templateCssText.replace(/{{assetsBaseUrl}}/g, this.assetsBaseUrl);
    templateHtmlText = templateHtmlText.replace(/{{assetsBaseUrl}}/g, this.assetsBaseUrl);
    templateHtmlText = templateHtmlText.replace(/{{assetsPortalBaseUrl}}/g, this.assetsPortalBaseUrl);


    // Angular コンポーネントを用意する
    @Component({
      selector: 'app-sign-in-main',
      template: templateHtmlText,
      styles: [templateCssText],
    })

    class SignInModuleComponent extends SignInMainComponent { }
    // Angular モジュールを用意する

    @NgModule({
      imports: [CommonModule, FormsModule, PopoverModule.forRoot()],
      declarations: [SignInModuleComponent],
      exports: [SignInModuleComponent]
    })
    class SignInModule {
    }

    // Angular モジュールとコンポーネントをコンパイルする
    const module = this.compiler.compileModuleAndAllComponentsSync(SignInModule);
    // Angular モジュールから SignInModuleComponent を生成するファクトリを取り出す
    const factory = module.componentFactories.find((c) => {
      return c.componentType === SignInModuleComponent;
    });

    // SignInModuleComponent を生成し this.dest に設定する
    const componentRef = this.dest.createComponent(factory);

    // componentのインスタンスを取得する。
    this.comp = (<SignInModuleComponent>componentRef.instance);
    this.comp.init(this, this.signInService, this.authService, this.waitModal);
  }
}
